import Header from '../../components/Header';
import Hero from '../../components/Hero';
import WhatsAppCTA from '../../components/WhatsAppCTA';
import Pricing from '../../components/Pricing';
import Space from '../../components/Space';
import Local from '../../components/Local';
import Contact from '../../components/Contact';
import Reviews from '../../components/Reviews';
import Closing from '../../components/Closing';
import FAQ from '../../components/FAQ';
import Footer from '../../components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <Hero />
      <WhatsAppCTA />
      {/* <Services /> */}
      <Pricing />
      <Space />
      <Local />
      <Contact />
      <Reviews />
      <Closing />
      <FAQ />
      <Footer />
    </>
  );
}
